<template>
  <div class="home">
    <div class="silder-home" v-if="AllBanner != null">
      <VueSlickCarousel v-bind="setting" v-if="IsLoad">
        <div class="image-Blog" v-for="(item, index) in AllBanner" :key="index">
          <img alt="" class="center-cropped" :src="item.banner_poster"/>
        </div>
      </VueSlickCarousel>
    </div>
    <v-container style="max-width: 1480px !important;">
      <div class="our-offer">
        <div class="title-our-offer mt-5">
          <h1>{{oracle.translate('همین حالا سفارش دهید!')}}</h1>
        </div>
        <v-col cols="12">
          <v-slide-group
              v-model="model"
              class="pa-4"
              mandatory
              show-arrows>
            <v-slide-item
                v-for="(n,index) in AllShop"
                :key="index"
                v-slot="{ active, toggle }">
              <v-card
                  :color="'#ffffff'"
                  class="ma-4"
                  width="125"
                  height="125"
                  v-ripple role="button" @click="toggle">
                <v-row
                    class="fill-height"
                    align="center"
                    justify="center" v-ripple role="button" @click="GoToSingleShop(n.shop_id)">
                  <div class=" bdg-our-offer">
                    <div class="shop_css" v-if="n.shop_delivery != false && n.shop_type == 0">
                      <p class="mrx-2">{{oracle.translate('پیک')}}</p>
                      <v-icon class="mlx-1 mrx-2">check</v-icon>
                    </div>
                    <div class="shop_css_offline" v-else-if="n.shop_delivery == false && n.shop_type == 0">
                      <p class="mlx-2 mrx-2">{{oracle.translate('حضوری')}}</p>
                    </div>
                  </div>
                  <div class="img-our-offer2">
                    <img alt="" :src="n.shop_cover"/>
                  </div>
                  <div class="text-our-offer-shop">
                    <span style="text-align: center !important;">{{ oracle.shop_name(n) }}</span>
                  </div>
                </v-row>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </div>
    </v-container>
    <div
        style="width: 100%; text-align: center !important;display: flex;justify-content: center;padding: 25px 0 25px 0;"
    >
      <div
          style="border-top: 2px solid #7ec352 ; color: #7ec352; width: 50%"
      ></div>
    </div>
    <div class="mb-5" style="text-align: center !important; ">
      <VueSlickCarousel v-bind="setting">
        <div class="d-flex flex-row" style="max-width: 1480px !important; min-width: unset !important;">
          <v-row justify="center">
            <div
                class="item-category-food"
                v-for="(item, index) in AllCat"
                :key="index">
              <router-link role="button"
                           :to="{ name: 'category', query: { id: item.category_id } }"
                           class="item-category">
                <div class="img-item-category">
                  <img alt="" :src="item.category_cover"/>
                </div>
                <div class="text-item-category">
                  <span class="font-weight-bold">{{ oracle.category_name(item) }}</span>
                </div>
              </router-link>
            </div>
          </v-row>
        </div>
      </VueSlickCarousel>
    </div>
    <div style="width: 100%; text-align: center !important;display: flex;justify-content: center;padding: 25px 0 25px 0;">
      <div style="border-top: 2px solid #7ec352 ; color: #7ec352; width: 50%"
      ></div>
    </div>
    <div class="home-item">
      <v-container>
        <v-row v-for="(item, index) in databanner" :key="index">
          <v-col class="bck-home-item" cols="6">
            <router-link role="button" :to="{name:'single', query: {id: item.product_id}}">
              <div class="banner-home">
                <img alt="" class="center-cropped" :src="item.product_special_image"/>
              </div>
            </router-link>
          </v-col>
          <v-col class="bck-home-item bck-mobile-item" cols="6">
            <div class="item-log-profile">
              <h1 class="multi-line">{{ oracle.product_title(item) }}</h1>
              <span>{{ item.product_special_text }}</span>
              <span v-if="item.product_discount != null && item.product_discount > 0"
                    style="background-color: #7dc353;"
                    color="#7ec352" class="span-show-discount">
                {{ item.product_discount }}%
              </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="our-offer">
      <div class="title-our-offer">
        <h1 class="">{{oracle.translate('پیشنهاد ما')}}</h1>
      </div>
      <v-container>
        <v-row justify="center">
          <div class="list-our-offer">
            <div
                class="item-our-offer"
                v-for="(item, index) in dataproduct"
                :key="index"
                v-ripple role="button" @click="GoToSingle(item.product_id)"
            >
              <div class="bdg-our-offers">
                <div class="itembdg-our-offer" v-if="item.product_discount > 0">
                  <p>{{ item.product_discount }}%</p>
                </div>
              </div>
              <div class="img-our-offer">
                <img alt="" :src="item.product_icon"/>
              </div>
              <div class="text-our-offer">
                <span style="text-align: center !important;" class="multi-line text-center mb-1">{{ oracle.product_title(item) }}</span>
                <span style="font-size: 14px;text-align: center !important;" class="font-weight-bold text-center">{{ oracle.format(item.product_sell_price) }} {{oracle.translate('تومان')}}</span>
              </div>
            </div>
          </div>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import oracle from "@/oracle";

export default {
  name: "home",
  components: {VueSlickCarousel},
  data: () => ({
    oracle: oracle,
    AllShop: [],
    model: null,
    IsLoad: false,
    AllCat: [],
    dataproduct: [],
    databanner: [],
    AllBanner: [],
    setting: {
      "dots": true,
      "infinite": true,
      "initialSlide": 2,
      "speed": 500,
      "slidesToShow": 1,
      "slidesToScroll": 1,
      "swipeToSlide": true,
      "autoplay": true
    },
    settingslide: {
      arrows: false,
      dots: false,
      autoplay: true,
      centerMode: false,
      infinite: false,
      slidesToShow: 5,
    },
    dataProduct: [{id: "0", count: 0}],
  }),
  methods: {
    GoToSingle(id) {
      this.$router.push({name: "single", query: {id: id}});
    },
    GoToSingleShop(id) {
      this.$router.push({name: "innerStore", query: {id: id}});
    },
    plus(id) {
      this.dataProduct.forEach((item) => {
        if (item.id === id) item.count += 1;
      });
    },
    minus(id) {
      this.dataProduct.forEach((item) => {
        if (item.id === id) item.count -= 1;
      });
    },
    GetCat(response) {
      this.AllCat = response.data;
    },
    GetInnerBanner(response) {
      let AllData = response.data;
      for (let i = 0; i < AllData.length; i++) {
        if (AllData[i].product_special == true) {
          let exist = false
          for (let j = 0; j < this.databanner.length; j++) {
            if (this.databanner[j].product_id == AllData[i].product_id) {
              exist = true
              break
            }
          }
          if (!exist) {
            this.databanner.push(AllData[i]);
          }
        }
      }
      for (let i = 0; i < AllData.length; i++) {
        if (AllData[i].product_trend == true) {
          let exist = false
          for (let j = 0; j < this.dataproduct.length; j++) {
            if (this.dataproduct[j].product_id == AllData[i].product_id) {
              exist = true
              break
            }
          }
          if (!exist) {
            this.dataproduct.push(AllData[i]);
          }
        }
      }
    },
    GetShop(response) {
      this.AllShop = response.data;
    },
    GetBannerShop(response) {
      this.AllBanner = response.data
      this.IsLoad = true
    }
  },
  mounted() {
    oracle.axios(
        "productCategory/getList",
        {offset_by: 0, limit_by: 1000, order_by: "priority"},
        this.GetCat
    );

    oracle.axios(
        "product/getList",
        {
          offset_by: 0,
          limit_by: 1000,
          order_by: "priority",
          filter_by: true,
        },
        this.GetInnerBanner
    );
    oracle.axios(
        "shop/getList",
        {
          offset_by: 0,
          limit_by: 1000,
          order_by: "priority",
        },
        this.GetShop
    );
    oracle.axios(
        "banner/getList",
        {
          offset_by: 0,
          limit_by: 1000,
          order_by: "priority",
        },
        this.GetBannerShop
    );
  },
};
</script>

<style>
.home .btnSelectCategory img {
  color: #fff !important;
  border-radius: 15px;
  margin: 5px;
  font-size: 10px !important;
  width: 100px;
  /*overflow: scroll;*/
}

.home .btnSelectCategory {
  overflow-x: scroll;
  overflow-y: hidden;
  display: flex;
  /*justify-content: center;*/
  align-items: center;
  flex-direction: row-reverse;
  margin-top: 10px;
  scrollbar-width: none;
}

.home .btnSelectCategory.sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  background-color: green;
  border: 2px solid #4CAF50;
}

.home .btn-selectCategory {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100% !important;
}

.home .btn-selectCategory2 {
  border-radius: 100px;
  height: 30px;
  padding: 5px 15px;
  margin: 0 3px;
  color: #fff;
  background: #011d33;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px !important;
  width: auto !important;
  white-space: nowrap !important;
  word-wrap: break-word;
}

.home .shop_css {
  background-color: #2ab0f7;
  width: auto;
  height: 25px;
  border-radius: 30px;
  display: flex !important;
  color: white;
  font-size: 10px;
  padding: 3px !important;
  margin: 0 !important;
  align-content: center;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
}

.home .shop_css_offline {
  background-color: #ffa000;
  width: auto;
  height: 25px;
  border-radius: 30px;
  display: flex !important;
  color: white;
  font-size: 10px;
  padding: 3px !important;
  margin: 0 !important;
  align-content: center;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
}

.home .shop_css .v-icon {
  font-size: 12px;
  color: white;
}

.home .shop_css p {
  text-align: center !important;
  margin-bottom: 0 !important;
}

.home .shop_css_offline p {
  text-align: center !important;
  margin-bottom: 0 !important;
}

.home {
  background: #fff;
}

.home .sliderBox {
  display: flex;
}

.home .image-Blog img {
  width: 100%;
}

.home .img-item-category {
  width: 110px;
  height: 110px;
}

.home .img-item-category img {
  width: 100%;
  height: 100%;
}

.home .item-category {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 15px;
}

.home .text-item-category span {
  font-size: 15px;
  color: #000;
}

.home .text-item-category {
  margin: 10px 0;
}

.home .img-item-category:hover img {
  animation: shakeimg 0.2s infinite;
  animation-duration: 0.3s;
}

@keyframes shakeimg {
  0% {
    transform: rotate(0deg);
  }

  20% {
    transform: rotate(-10deg);
  }

  60% {
    transform: rotate(-10deg);
  }

  80% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.home .banner-home,
.home .item-log-profile {
  width: 100%;
  height: 310px;
}

.home .banner-home img {
  width: 100%;
  height: 100%;
}

/*.home-item {*/
/*    display: flex;*/
/*}*/

.home .bck-home-item {
  background: #f2f6f9;
  padding: 0 !important;
  margin-top: 20px;
  width: 100%;
}

.home .item-log-profile h1 {
  color: #333;
  font-size: 24px;
  padding: 20px 0;
}

.home .slick-dots {
  text-align: center !important;
}

.home .item-log-profile {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.home .span-show-discount {
  color: #fff !important;
  width: 15%;
  border-radius: 25px;
  font-size: 15px !important;
  padding: 6px;
  text-align: center !important;
  margin-top: 15px;
}

.home .item-our-offers,
.home .item-our-offer,
.home .text-our-offer,
.home .text-our-offer-shop {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  cursor: pointer;
  text-align: center !important;
  width: 100%;
}

.home .list-our-offer {
  display: flex;
}

.home .item-our-offer,
.home .item-our-offers {
  position: relative;
  margin: 15px 20px;
}

.home .img-our-offer {
  width: 100px;
  height: 100px;
  border-radius: 100px;
  overflow: hidden;
}

.home .img-our-offer2 {
  text-align: center !important;
}

.home .img-our-offer img {
  width: 100%;
  height: 100%;
}

.home .img-our-offer2 img {
  width: 50%;
  height: 50%;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
  border-radius: 50px;
}

.home .text-our-offer span {
  font-size: 13px;
  margin-top: unset !important;
  color: black;
}

.home .text-our-offer span:last-child {
  color: #7ec352;
  font-size: 12px;
}

.home .text-our-offer {
  text-align: center !important;
}

.home .text-our-offer-shop span {
  font-size: 13px;
  margin-top: unset !important;
  color: black;
  width: 80%;
}

/*.text-our-offer-shop span:last-child {*/
/*    color: black;*/
/*    font-size: 12px;*/
/*}*/

.home .text-our-offer-shop {
  text-align: center !important;
  margin: unset !important;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.home .bdg-our-offer {
  position: absolute;
  top: -4px;
  left: -17px;
}

.home .bdg-our-offers {
  position: absolute;
  top: 4px;
  left: -5px;
}

.home .bdg-our-offer ul {
  display: flex;
  border: 2px solid #7ec352;
  background: #fff;
  border-radius: 25px;
  justify-content: space-between;
  padding: 0 3px !important;
}

.home .slick-list {
  direction: ltr !important;
}

.home .v-slide-group__wrapper {
  direction: ltr !important;
}

.home .bdg-our-offer ul li .v-icon {
  color: #7ec352;
  font-size: 18px !important;
}

.home .bdg-our-offer ul li:nth-child(2) {
  padding: 0 5px;
}

.home .v-slide-group {
  direction: ltr !important;
}

.home .title-our-offer h1 {
  font-size: 23px;
  font-weight: normal;
}

.home .title-our-offer {
  display: flex;
  justify-content: center !important;
}

.home .our-offer {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.home .itembdg-our-offer {
  background-color: #a7d38d;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.home .itembdg-our-offer p {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin: 0;
}

/*@media only screen and (max-width: 480px) {*/
/*.home-item {*/
/*    display: flex;*/
/*    flex-direction: column;*/
/*}*/
/*.banner-home {*/
/*    width: 100%;*/
/*    height: 100%;*/
/*}*/
/*.bck-mobile-item {*/
/*    margin: 0;*/
/*    !*height: 145px;*!*/
/*    max-width: 100%;*/
/*}*/
/*.home .bck-mobile-item span:nth-child(2) {*/
/*    padding: 0 5px 0 5px;*/
/*}*/

/*.item-log-profile {*/
/*    width: 340px;*/
/*    !*justify-content: end;*!*/
/*    max-width: 100%;*/
/*}*/
/*.list-our-offer {*/
/*    display: flex;*/
/*    flex-wrap: nowrap;*/
/*    overflow: auto;*/
/*}*/
/*}*/
</style>
